import Config              from '../../../State/Stores/Config/Config';
import arrayBufferToString from '../../Shared/Util/arrayBufferToString';
import stringToUint8Array  from '../../Shared/Util/stringToUint8Array';
import LoadError           from '../Constants/LoadError';

/**
 * Requests a FairPlay certificate from the certificate URL provided via
 * the configuration, and returns it as a `Uint8Array`.
 */

const requestCertificate = (config: Config): Promise<Uint8Array> =>
    fetch(config.drm.fairplayCertificateUrl)
        .then(response => {
            if (!response.ok) throw new Error(LoadError.CERTIFICATE_REQUEST_FAILED);

            return response.arrayBuffer();
        })
        .then(arrayBufferToString)
        .then(stringToUint8Array);

export default requestCertificate;